(() => {
  const setup = (scope = document) => {
    scope.querySelectorAll('[data-occasion-tabs]').forEach((navSection) => {
      if (navSection.dataset.occasionReady === 'true') return;
      navSection.dataset.occasionReady = 'true';
      const links = [...navSection.querySelectorAll('[data-occasion-target]')];
      const targets = links.map((link) => document.getElementById(link.dataset.occasionTarget)).filter(Boolean);
      const activate = (id) => links.forEach((link) => link.classList.toggle('is-active', link.dataset.occasionTarget === id));
      links.forEach((link) => link.addEventListener('click', (event) => {
        const target = document.getElementById(link.dataset.occasionTarget);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        activate(target.id);
        if (history.replaceState) history.replaceState(null, '', `#${target.id}`);
      }));
      if ('IntersectionObserver' in window && targets.length) {
        const observer = new IntersectionObserver((entries) => {
for (const entry of entries) {
            if (entry.isIntersecting) {
              activate(entry.target.id);
              break;
            }
          }
        }, { rootMargin: '-22% 0px -62% 0px', threshold: 0.01 });
        targets.forEach((target) => observer.observe(target));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();